import React, { useEffect } from 'react';

const MutualFundPage = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css";
    link.rel = "stylesheet";
    link.id = "tailwind-mutualfund"; // Add ID so you can remove it later if needed
    document.head.appendChild(link);

    return () => {
      // Optional: Clean up when component unmounts
      document.getElementById("tailwind-mutualfund")?.remove();
    };
  }, []);

  return (
    <>
      {/* <!-- Hero Section --> */}
      <section className="bg-blue-50 py-16 text-center">
        <h1 className="text-4xl font-bold text-blue-900 mb-4">Start Your Wealth Journey with Smart Mutual Fund Investments</h1>
        <p className="text-lg text-gray-700 mb-6">Invest in expertly curated mutual fund portfolios designed to meet your goals — be it wealth creation, tax saving, or retirement planning.</p>
        <div ><a className="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login">Explore Mutual Fund Plans</a></div>
      </section>

      {/* <!-- Why Choose GPS Finvest --> */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">Why Choose GPS Finvest?</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-green-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Trusted Guidance</h3>
              <p>Certified experts help you choose the best funds tailored to your goals.</p>
            </div>
            <div className="hover-card bg-green-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Seamless Experience</h3>
              <p>From KYC to investment, everything is paperless and fast.</p>
            </div>
            <div className="hover-card bg-green-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Real-Time Tracking</h3>
              <p>Track your investments 24x7 with smart dashboards and insights.</p>
            </div>
            <div className="hover-card bg-green-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Personalized Support</h3>
              <p>Get support from our team via chat, call or email whenever needed.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Mutual Fund Categories --> */}
      <section className="bg-white py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-extrabold text-gray-900">Explore Our Mutual Fund Categories</h2>
          <p className="mt-4 text-lg text-gray-500">Choose the fund that aligns with your investment goals.</p>
        </div>

        <div className="mt-12 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {/* <!-- Cards with icons --> */}
          <div className="bg-green-50 p-6 rounded-lg shadow hover:shadow-lg transform hover:scale-105 transition duration-300"
            style={{ backgroundColor: "rgb(170 219 226)" }}>
            <img src="https://cdn-icons-png.flaticon.com/512/7628/7628893.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-green-700">Large Cap Funds</h3>
            <p className="mt-2 text-gray-600">Stable and reliable. Invests in top-performing companies.</p>
          </div>

          <div className="p-6 rounded-lg shadow hover:shadow-lg transform hover:scale-105 transition duration-300"
            style={{ backgroundColor: 'rgb(255 255 255) !important' }}>
            <img src="/images/Mid_Cap_Funds.png" alt="Mid Cap" className="w-16 h-16 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-green-700">Mid Cap Funds</h3>
            <p className="mt-2 text-gray-600">Great for growth-focused investors. Moderate risk and returns.</p>
          </div>

          <div className="bg-green-50 p-6 rounded-lg shadow hover:shadow-lg transform hover:scale-105 transition duration-300"
            style={{ backgroundColor: "rgb(170 219 226)" }}>
            <img src="https://cdn-icons-png.flaticon.com/512/7628/7628922.png" alt="Small Cap" className="w-16 h-16 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-green-700">Small Cap Funds</h3>
            <p className="mt-2 text-gray-600">High return potential with higher risk in emerging companies.</p>
          </div>

          <div className="p-6 rounded-lg shadow hover:shadow-lg transform hover:scale-105 transition duration-300"
            style={{ backgroundColor: 'rgb(255 255 255)!important' }}>
            <img src="https://cdn-icons-png.flaticon.com/512/2621/2621083.png" alt="Hybrid Fund" className="w-16 h-16 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-green-700">Hybrid Funds</h3>
            <p className="mt-2 text-gray-600">Balanced mix of equity and debt. Ideal for new investors.</p>
          </div>

          <div className="bg-green-50 p-6 rounded-lg shadow hover:shadow-lg transform hover:scale-105 transition duration-300"
            style={{ backgroundColor: "rgb(170 219 226)" }} >
            <img src="https://cdn-icons-png.flaticon.com/512/2501/2501373.png" alt="Debt Fund" className="w-16 h-16 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-green-700">Debt Funds</h3>
            <p className="mt-2 text-gray-600">Low-risk, fixed-income investments for stable returns.</p>
          </div>

          <div className="p-6 rounded-lg shadow hover:shadow-lg transform hover:scale-105 transition duration-300"
            style={{ backgroundColor: 'rgb(255 255 255)!important' }}>
            <img src="/images/ELSS_Funds.jpg" alt="ELSS Fund" className="w-16 h-16 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-green-700">ELSS Funds</h3>
            <p className="mt-2 text-gray-600">Tax-saving mutual funds under 80C with long-term wealth growth.</p>
          </div>
        </div>
      </section>

      {/* <!-- How to Start Section --> */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">How to Start Investing with GPS Finvest</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">1. Sign Up</h3>
              <p>Create your free account using PAN and mobile number.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">2. Complete KYC</h3>
              <p>Verify your identity via paperless Aadhaar-based eKYC.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">3. Set Your Goal</h3>
              <p>Choose your investment objective — wealth, tax-saving, etc.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">4. Start Investing</h3>
              <p>Start SIP or lump-sum investments with as low as ₹500.</p>
            </div>
          </div>
        </div>
      </section>




      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">What is a Mutual Fund?</h2>
          <p className="text-lg text-gray-600">A mutual fund is an investment vehicle that pools money from multiple investors to invest in a diversified portfolio of stocks, bonds, or other securities. Managed by professional fund managers, mutual funds offer an easy and efficient way to grow your wealth while spreading risk across various assets.</p>
        </div>
      </section>

      {/* <!-- Mutual Fund Comparison Table --> */}
      <section className="py-16 bg-green-50" style={{ background: 'rgb(226 251 255)' }}>
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-10">Compare Mutual Fund Categories</h2>
          <div className="overflow-x-auto rounded-lg shadow">
            <table className="min-w-full table-auto text-sm text-left border border-gray-200">
              <thead className="bg-green-200 text-green-900" >
                <tr>
                  <th className="px-6 py-4 border">Fund Type</th>
                  <th className="px-6 py-4 border">Risk Level</th>
                  <th className="px-6 py-4 border">Return Potential</th>
                  <th className="px-6 py-4 border">Ideal For</th>
                  <th className="px-6 py-4 border">Lock-in Period</th>
                  <th className="px-6 py-4 border">Tax Benefit</th>
                </tr>
              </thead>
              <tbody className="bg-white text-gray-800">
                <tr className="tabletr transition">
                  <td className="px-6 py-4 border">Large Cap</td>
                  <td className="px-6 py-4 border">Low to Moderate</td>
                  <td className="px-6 py-4 border">Stable</td>
                  <td className="px-6 py-4 border">Long-term conservative investors</td>
                  <td className="px-6 py-4 border">None</td>
                  <td className="px-6 py-4 border">No</td>
                </tr>
                <tr className="tabletr transition">
                  <td className="px-6 py-4 border">Mid Cap</td>
                  <td className="px-6 py-4 border">Moderate</td>
                  <td className="px-6 py-4 border">Moderate to High</td>
                  <td className="px-6 py-4 border">Growth-focused investors</td>
                  <td className="px-6 py-4 border">None</td>
                  <td className="px-6 py-4 border">No</td>
                </tr>
                <tr className="tabletr transition">
                  <td className="px-6 py-4 border">Small Cap</td>
                  <td className="px-6 py-4 border">High</td>
                  <td className="px-6 py-4 border">Very High</td>
                  <td className="px-6 py-4 border">Aggressive investors</td>
                  <td className="px-6 py-4 border">None</td>
                  <td className="px-6 py-4 border">No</td>
                </tr>
                <tr className="tabletr transition">
                  <td className="px-6 py-4 border">Hybrid</td>
                  <td className="px-6 py-4 border">Moderate</td>
                  <td className="px-6 py-4 border">Balanced</td>
                  <td className="px-6 py-4 border">First-time investors</td>
                  <td className="px-6 py-4 border">None</td>
                  <td className="px-6 py-4 border">No</td>
                </tr>
                <tr className="tabletr transition">
                  <td className="px-6 py-4 border">Debt</td>
                  <td className="px-6 py-4 border">Low</td>
                  <td className="px-6 py-4 border">Low to Moderate</td>
                  <td className="px-6 py-4 border">Risk-averse investors</td>
                  <td className="px-6 py-4 border">None</td>
                  <td className="px-6 py-4 border">No</td>
                </tr>
                <tr className="tabletr transition">
                  <td className="px-6 py-4 border">ELSS</td>
                  <td className="px-6 py-4 border">Moderate</td>
                  <td className="px-6 py-4 border">High (Long-term)</td>
                  <td className="px-6 py-4 border">Tax-saving investors</td>
                  <td className="px-6 py-4 border">3 Years</td>
                  <td className="px-6 py-4 border">Yes (under 80C)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
};

export default MutualFundPage;
